import { render } from "./Disclaimer.vue?vue&type=template&id=36d3f1cd&scoped=true&ts=true"
import script from "./Disclaimer.vue?vue&type=script&lang=ts"
export * from "./Disclaimer.vue?vue&type=script&lang=ts"

import "./Disclaimer.vue?vue&type=style&index=0&id=36d3f1cd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d3f1cd"]])

export default __exports__